import React, { PropsWithChildren } from 'react';

import { Box, Dialog, H1, Text } from '@betterment/samba-react';

import { OutboundIntegration } from '../../graphql/schema';

const IntegrationConnectModal: React.FC<
  PropsWithChildren<{
    integration: OutboundIntegration;
    title: string;
  }>
> = ({ integration, title, children }) => {
  return (
    <Dialog.Content css={{ minWidth: '640px', p: 'space.400' }}>
      <Dialog.Title asChild={true}>
        <H1 variant="title300" css={{ pb: 'space.150' }}>
          {title}
        </H1>
      </Dialog.Title>
      <Dialog.Description asChild={true}>
        <Box>
          <Box
            css={{
              pt: 'space.150',
            }}
          >
            <Text color="text" variant="text100">
              {integration.description}
            </Text>
          </Box>
          <Box
            css={{
              pt: 'space.300',
            }}
          >
            <Text color="text" variant="text100">
              The information we’ll send to {integration.name} includes:
            </Text>
          </Box>
          <Box
            css={{
              mt: 'space.100',
              p: 'space.50',
              backgroundColor: 'background',
            }}
          >
            <ul>
              {integration.components?.map(component => (
                <li key={component}>
                  <Text color="text" variant="text100">
                    {component}
                  </Text>
                </li>
              ))}
            </ul>
          </Box>
          {children}
        </Box>
      </Dialog.Description>
    </Dialog.Content>
  );
};

export default IntegrationConnectModal;
